import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Sticky Bucketing`}</h1>
    <p>{`Optionally add a storage layer when instantiating tesfy by conforming to the protocol `}<inlineCode parentName="p">{`TesfyStorable`}</inlineCode>{`. This layer could be whatever you want (UserDefaults, Keychain, Core Data, SQLite, etc.). This way even allocation or attributes changes in users will stick with the same variation.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`class TesfyStorage: TesfyStorable {
    var storage: [String: String]

    init(storage: [String: String]? = [:]) {
        self.storage = storage ?? [:]
    }

    func get(id: String) -> String? {
        return storage[id]
    }

    func store(id: String, value: String?) {
        self.storage[id] = value
    }
}

let tesfyStorage = TesfyStorage()
let tesfy = Tesfy(datafile: datafile, storage: tesfyStorage)

let userId = "676380e0-7793-44d6-9189-eb5868e17a86"
let experimentId = "experiment-2"

tesfy.getVariationId(experimentId: experimentId, userId: userId, attributes: "{ \\"countryCode\\": \\"us\\" }") // "0"
tesfy.getVariationId(experimentId: experimentId, userId: userId, attributes: "{ \\"countryCode\\": \\"ve\\" }") // "0"
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      